module.exports = __webpack_public_path__ + "img/stars-sky.8a1a56f8.png";